const ACTION_TYPES = {
  SET_INIT_FORM: "setInitForm",
  SET_NEW_BANK_ACCOUNT: "setNewBankAccount",
  SET_GATEWAY_LIST: "setGatewayList",
  SET_TERMINAL_LIST: "setTerminalList",
  SET_NEW_ACCOUNT_MODAL: "setNewAccountModal",
  SET_LOADING: "setLoading",
  SET_ERROR: "setError",
  SET_GATEWAY_INFO: "setGatewayInfo",
};

const gatewayReducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_LOADING:
      const { loading } = action.payload;
      return {
        ...state,
        loading,
      };

    case ACTION_TYPES.SET_ERROR:
      const { error } = action.payload;
      return {
        ...state,
        error,
      };

    case ACTION_TYPES.SET_INIT_FORM:
      const { bankAccounts, mainCategories, psp } = action.payload;
      return {
        ...state,
        bankAccounts,
        mainCategories,
        psp,
      };

    case ACTION_TYPES.SET_GATEWAY_LIST:
      const { gateway } = action.payload;
      return {
        ...state,
        gatewayList: gateway,
      };

    case ACTION_TYPES.SET_TERMINAL_LIST:
      const { terminals } = action.payload;
      return {
        ...state,
        terminalList: terminals,
      };

    case ACTION_TYPES.SET_NEW_ACCOUNT_MODAL:
      const { isOpen } = action.payload;
      return {
        ...state,
        newAccountModal: isOpen,
      };
    case ACTION_TYPES.SET_NEW_BANK_ACCOUNT:
      const { bankAccount } = action.payload;
      return {
        ...state,
        bankAccounts: [...state.bankAccounts, bankAccount],
      };

    case ACTION_TYPES.SET_GATEWAY_INFO:
      const { gatewayInfo } = action.payload;
      return {
        ...state,
        gatewayInfo: gatewayInfo,
      };

    default:
      return state;
  }
};

export default gatewayReducer;
